// src/school/pages/EditStudent.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../services/api";
import "./addStudent.css";

export default function EditStudent() {

  const { id } = useParams();
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState(null);

  const [form, setForm] = useState({

    // BASIC
    name: "",
    student_id: "",
    student_password: "",

    parent_id: "",
    parent_password: "",

    class_model: "",
    section: "",

    roll_number: "",
    gender: "",
    dob: "",

    religion: "",
    emis_number: "",

    blood_group: "",
    aadhaar_number: "",

    // PARENT
    parent_name: "",
    parent_phone: "",

    father_name: "",
    mother_name: "",
    guardian_name: "",

    parent_email: "",
    parent_qualification: "",
    parent_income: "",

    notes: "",
    address: "",
  });

  // ================= LOAD CLASSES =================
  const loadClasses = async () => {

    const res = await API.get("/school-admin/classes/", {
      headers: {
        "X-SCHOOL-ID": school.school.id,
      },
    });

    setClasses(res.data.classes);
  };

  // ================= LOAD SECTIONS =================
  const loadSections = async (classId) => {

    if (!classId) return;

    const res = await API.get(
      `/school-admin/sections/${classId}/`,
      {
        headers: {
          "X-SCHOOL-ID": school.school.id,
        },
      }
    );

    setSections(res.data.sections);
  };

  // ================= LOAD STUDENT =================
  const loadStudent = async () => {

    const res = await API.get(
      `/school-admin/students/${id}/`,
      {
        headers: {
          "X-SCHOOL-ID": school.school.id,
        },
      }
    );

    const s = res.data;

    setForm({

      name: s.name || "",

      student_id: s.student_id || "",
      student_password: s.student_password || "",

      parent_id: s.parent_id || "",
      parent_password: s.parent_password || "",

      class_model: s.class_id || "",
      section: s.section_id || "",

      roll_number: s.roll_number || "",
      gender: s.gender || "",
      dob: s.dob || "",

      religion: s.religion || "",
      emis_number: s.emis_number || "",

      blood_group: s.blood_group || "",
      aadhaar_number: s.aadhaar_number || "",

      parent_name: s.parent_name || "",
      parent_phone: s.parent_phone || "",

      father_name: s.father_name || "",
      mother_name: s.mother_name || "",
      guardian_name: s.guardian_name || "",

      parent_email: s.parent_email || "",
      parent_qualification: s.parent_qualification || "",
      parent_income: s.parent_income || "",

      notes: s.notes || "",
      address: s.address || "",
    });

    if (s.photo) {
      setPreview(s.photo);
    }

    loadSections(s.class_id);
  };

  useEffect(() => {
    loadClasses();
    loadStudent();
  }, []);

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "class_model") {
      loadSections(e.target.value);
    }
  };

  // ================= PHOTO =================
  const handlePhoto = (file) => {
    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleFileSelect = (e) => {

    const file = e.target.files[0];

    if (file) {
      handlePhoto(file);
    }
  };

  const handleDrop = (e) => {

    e.preventDefault();

    const file = e.dataTransfer.files[0];

    if (file) {
      handlePhoto(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // ================= UPDATE =================
  const handleSubmit = async (e) => {

    e.preventDefault();

    const fd = new FormData();

    Object.keys(form).forEach((key) => {
      fd.append(key, form[key]);
    });

    if (photo) {
      fd.append("photo", photo);
    }

    try {

      await API.put(
        `/school-admin/students/update/${id}/`,
        fd,
        {
          headers: {
            "X-SCHOOL-ID": school.school.id,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Student updated successfully!");

      window.location.href = "/school-admin/students";

    } catch (err) {

      console.log(err);
      alert("Error updating student");
    }
  };

  return (


      <div className="add-student-container">

        <h2>Edit Student</h2>

        <form
          onSubmit={handleSubmit}
          className="add-student-form"
        >

          {/* PHOTO */}
          <div
            className="photo-upload-box"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >

            {preview ? (
              <img
                src={preview}
                className="preview-image"
                alt=""
              />
            ) : (
              <div className="upload-text">
                Drag & Drop Student Photo
                <br />
                OR
                <br />

                <label className="upload-btn">
                  Choose File

                  <input
                    type="file"
                    hidden
                    onChange={handleFileSelect}
                  />
                </label>
              </div>
            )}

          </div>

          {/* STUDENT NAME */}
          <div className="form-group">
            <label>Student Name</label>

            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* STUDENT LOGIN */}
          <div className="form-row">

            <div className="form-group">
              <label>Student ID</label>

              <input
                type="text"
                name="student_id"
                value={form.student_id}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Student Password</label>

              <input
                type="text"
                name="student_password"
                value={form.student_password}
                onChange={handleChange}
              />
            </div>

          </div>

          {/* PARENT LOGIN */}
          <div className="form-row">

            <div className="form-group">
              <label>Parent Login ID</label>

              <input
                type="text"
                name="parent_id"
                value={form.parent_id}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Parent Password</label>

              <input
                type="text"
                name="parent_password"
                value={form.parent_password}
                onChange={handleChange}
              />
            </div>

          </div>

          {/* CLASS + SECTION */}
          <div className="form-row">

            <div className="form-group">
              <label>Class</label>

              <select
                name="class_model"
                value={form.class_model}
                onChange={handleChange}
                required
              >

                <option value="">
                  Select Class
                </option>

                {classes.map((c) => (
                  <option
                    key={c.id}
                    value={c.id}
                  >
                    {c.name}
                  </option>
                ))}

              </select>
            </div>

            <div className="form-group">
              <label>Section</label>

              <select
                name="section"
                value={form.section}
                onChange={handleChange}
                required
              >

                <option value="">
                  Select Section
                </option>

                {sections.map((s) => (
                  <option
                    key={s.id}
                    value={s.id}
                  >
                    {s.name}
                  </option>
                ))}

              </select>
            </div>

          </div>

          {/* OTHER DETAILS */}
          <div className="form-group">
            <label>Roll Number</label>

            <input
              type="text"
              name="roll_number"
              value={form.roll_number}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Gender</label>

            <select
              name="gender"
              value={form.gender}
              onChange={handleChange}
            >

              <option value="">
                Select Gender
              </option>

              <option>Male</option>
              <option>Female</option>

            </select>
          </div>

          <div className="form-group">
            <label>Date of Birth</label>

            <input
              type="date"
              name="dob"
              value={form.dob}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Religion</label>

            <input
              type="text"
              name="religion"
              value={form.religion}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>EMIS Number</label>

            <input
              type="text"
              name="emis_number"
              value={form.emis_number}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Blood Group</label>

            <input
              type="text"
              name="blood_group"
              value={form.blood_group}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Aadhaar Number</label>

            <input
              type="text"
              name="aadhaar_number"
              value={form.aadhaar_number}
              onChange={handleChange}
            />
          </div>

          {/* PARENT DETAILS */}
          <h4 className="section-title">
            Parent Details
          </h4>

          <div className="form-group">
            <label>Parent Name</label>

            <input
              type="text"
              name="parent_name"
              value={form.parent_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Father Name</label>

            <input
              type="text"
              name="father_name"
              value={form.father_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Mother Name</label>

            <input
              type="text"
              name="mother_name"
              value={form.mother_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Guardian Name</label>

            <input
              type="text"
              name="guardian_name"
              value={form.guardian_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Parent Phone</label>

            <input
              type="text"
              name="parent_phone"
              value={form.parent_phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Parent Email</label>

            <input
              type="email"
              name="parent_email"
              value={form.parent_email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Parent Qualification</label>

            <input
              type="text"
              name="parent_qualification"
              value={form.parent_qualification}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Parent Income</label>

            <input
              type="text"
              name="parent_income"
              value={form.parent_income}
              onChange={handleChange}
            />
          </div>

          {/* ADDRESS */}
          <div className="form-group">
            <label>Address</label>

            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
            />
          </div>

          {/* NOTES */}
          <div className="form-group">
            <label>Notes</label>

            <textarea
              name="notes"
              value={form.notes}
              onChange={handleChange}
            />
          </div>

          {/* SUBMIT */}
          <button className="btn-submit">
            Update Student
          </button>

        </form>

      </div>


  );
}